// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__FHsjr","upload":"Small_upload__2Xjqo","imageWrap":"Small_imageWrap__1N41C","removeBtn":"Small_removeBtn__26n_B"};